<template>
  <div class="home-wrapper">
    <!-- 顶部 Banner -->
    <div class="hero-section">
      <BannerScroll></BannerScroll>
    </div>

    <main class="main-content">
      <!-- 动态资讯板块：招标公告 + 通知公告 -->
      <section class="news-dynamic-section container-fixed">
        <div class="dynamic-grid">
          <!-- 广西招投标最新项目信息 -->
          <div class="dynamic-card card-modern">
            <div class="card-header">
              <h2 class="title">广西招投标最新项目信息</h2>
              <router-link to="/invitation" class="more-link"
                >查看更多 <i class="el-icon-right"></i
              ></router-link>
            </div>
            <div class="card-list">
              <div
                v-for="(item, index) in noticelist"
                :key="index"
                @click="goInfo(item)"
                class="list-item"
              >
                <span class="dot"></span>
                <span class="item-title">{{ item.title }}</span>
                <span class="item-date">{{ item.publishDate }}</span>
              </div>
            </div>
          </div>

          <!-- 右侧：CA入口 + 通知公告 -->
          <div class="dynamic-sidebar">
            <!-- CA 入口 CTA -->
            <div class="ca-cta-card" @click="getCA">
              <div class="cta-content">
                <img
                  src="../assets/images/lock2.png"
                  alt="西部CA"
                  class="cta-icon"
                />
                <div class="cta-text">
                  <h3>西部CA办理入口</h3>
                  <p>便捷办理 · 安全可靠</p>
                </div>
              </div>
              <div class="cta-arrow">
                <i class="el-icon-right"></i>
              </div>
            </div>

            <!-- 通知公告 -->
            <div class="dynamic-card card-modern">
              <div class="card-header">
                <h2 class="title">通知公告</h2>
                <router-link to="/noticelist" class="more-link"
                  >更多</router-link
                >
              </div>
              <div class="card-list mini">
                <div
                  v-for="(item, index) in infolist"
                  :key="index"
                  @click="getnoticeDetail(item.id)"
                  class="list-item"
                >
                  <span class="item-title">{{ item.title }}</span>
                  <span class="item-date">{{ item.releaseTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 更多服务板块 -->
      <section
        class="services-section container-fixed"
        v-if="productTypeList && productTypeList.length > 0"
      >
        <div class="section-header">
          <div class="en-title">MORE SERVICES</div>
          <div class="cn-title">更多服务</div>
        </div>

        <div class="services-grid">
          <div
            class="service-card card-modern"
            v-for="item in productTypeList"
            :key="item.service ? item.service.id : Math.random()"
          >
            <div
              class="service-banner"
              :style="{
                backgroundImage: item.service
                  ? `url(${item.service.picLoad})`
                  : '',
              }"
              @click="item.service && getService(item.service.serviceType)"
            >
              <div class="overlay" v-if="item.service">
                <h3>{{ item.service.serviceTitle }}</h3>
                <span class="view-more"
                  >了解详情 <i class="el-icon-right"></i
                ></span>
              </div>
            </div>
            <div class="service-product-list" v-if="item.products">
              <div
                v-for="(arr, index) in item.products.slice(0, 4)"
                :key="index"
                @click="getProductDetail(arr.id)"
                class="product-link"
              >
                <i class="el-icon-caret-right"></i>
                <span>{{ arr.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 侧边服务悬浮组件 已移至 App.vue -->
    </main>
  </div>
</template>

<script>
import article from "@/api/article";
import BannerScroll from "./../components/bannerScroll.vue";

export default {
  name: "homeIndex",
  components: {
    BannerScroll,
  },
  data() {
    return {
      noticelist: [],
      infolist: [],
      productTypeList: [],
    };
  },
  mounted() {
    this.handleGetData();
    this.getInfolist();
    this.serviceData();
  },
  activated() {
    // 当组件从 keep-alive 缓存中恢复时调用
    // 如果数据丢失，重新获取一次
    if (this.noticelist.length === 0) this.handleGetData();
    if (this.infolist.length === 0) this.getInfolist();
    if (this.productTypeList.length === 0) this.serviceData();
  },
  methods: {
    handleGetData() {
      article
        .getList({ current: 1, size: 8 })
        .then((res) => {
          const data = res.data.data;
          if (data && data.records) {
            this.noticelist = data.records.map((item) => {
              return {
                ...item,
                publishDate: item.publishDate
                  ? item.publishDate.slice(0, 10)
                  : "",
              };
            });
          }
        })
        .catch((err) => {
          console.error("获取招投标数据失败:", err);
        });
    },
    goInfo(item) {
      this.$router.push({
        path: "/listinfo",
        query: { articleId: item.articleId },
      });
    },
    getInfolist() {
      article
        .noticeList()
        .then((res) => {
          const data = res.data.data;
          if (data && data.records) {
            this.infolist = data.records.slice(0, 5).map((item) => {
              return {
                ...item,
                releaseTime: item.releaseTime
                  ? item.releaseTime.slice(0, 10)
                  : "",
              };
            });
          }
        })
        .catch((err) => {
          console.error("获取通知公告失败:", err);
        });
    },
    serviceData() {
      article
        .serviceProductList()
        .then((res) => {
          if (res.data && res.data.data) {
            const data = res.data.data;
            if (Array.isArray(data)) {
              this.productTypeList = data;
            } else if (data.records && Array.isArray(data.records)) {
              this.productTypeList = data.records;
            } else {
              this.productTypeList = [];
            }
          }
        })
        .catch((err) => {
          console.error("获取服务数据失败:", err);
          this.productTypeList = [];
        });
    },
    getnoticeDetail(id) {
      this.$router.push({ path: "/noticedetail", query: { id } });
    },
    getService(serviceType) {
      this.$router.push({ path: "/projectlist", query: { serviceType } });
    },
    getProductDetail(id) {
      this.$router.push({ path: "/projectdetail", query: { id } });
    },
    getCA() {
      this.$router.push({ path: "/camodule" });
    },
  },
};
</script>

<style scoped lang="less">
@import "../assets/styles/variables.less";

.home-wrapper {
  background-color: @bg-base;
}

.hero-section {
  position: relative;
  /deep/ .nav-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
  }
}

.main-content {
  padding-bottom: @space-xxl;
}

/* 动态资讯板块 */
.news-dynamic-section {
  margin-top: @space-xl;
}

.dynamic-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: @space-lg;
  align-items: start; // 顶部对齐，防止被拉伸变形
}

.dynamic-sidebar {
  display: flex;
  flex-direction: column;
  min-width: 0; // 防止子元素撑开 grid 单元格
  gap: @space-lg; // 统一子元素间距
}

.dynamic-card {
  padding: 0;
  display: flex;
  flex-direction: column;
  min-width: 0; // 同样防止内容撑开单元格
  width: 100%; // 确保占满列宽

  .card-header {
    padding: @space-lg @space-xl;
    border-bottom: 1px solid @border-color;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: @font-size-xl;
      font-weight: 700;
      color: @text-main;
      position: relative;
      padding-left: 12px;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background-color: @primary-color;
        border-radius: 2px;
      }
    }

    .more-link {
      font-size: 14px;
      color: @text-muted;
      &:hover {
        color: @primary-color;
      }
    }
  }
}

.card-list {
  padding: @space-md @space-xl;

  .list-item {
    display: flex;
    align-items: center;
    padding: @space-md 0;
    border-bottom: 1px dashed @border-color;
    cursor: pointer;
    transition: all 0.2s;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      .item-title {
        color: @primary-color;
        transform: translateX(4px);
      }
    }

    .dot {
      width: 6px;
      height: 6px;
      background-color: @text-muted;
      border-radius: 50%;
      margin-right: @space-md;
    }

    .item-title {
      flex: 1;
      font-size: 15px;
      color: @text-secondary;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: all 0.3s;
    }

    .item-date {
      font-size: 14px;
      color: @text-muted;
      margin-left: @space-lg;
    }
  }

  &.mini {
    padding: @space-md @space-lg;
    .list-item {
      padding: 12px 0;
      .item-title {
        font-size: 14px;
      }
    }
  }
}

/* CA CTA Card */
.ca-cta-card {
  background: linear-gradient(135deg, @primary-color, @primary-hover);
  border-radius: @border-radius;
  padding: 32px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%; // 占满父容器
  box-sizing: border-box; // 包含 padding
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: @shadow-md;

  &:hover {
    box-shadow: @shadow-lg;
    transform: translateY(-4px) scale(1.02);
  }

  .cta-content {
    display: flex;
    align-items: center;
    gap: 20px;
    min-width: 0; // 防止文本撑开容器

    .cta-icon {
      flex-shrink: 0; // 防止图标被压缩
      width: 56px;
      height: 56px;
      filter: brightness(0) invert(1);
    }

    .cta-text {
      min-width: 0; // 同样防止文本撑开
      overflow: hidden;
    }

    h3 {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 4px;
      white-space: nowrap; // 标题不换行
      overflow: hidden;
      text-overflow: ellipsis; // 超出显示省略号
    }
    p {
      font-size: 14px;
      opacity: 0.9;
    }
  }

  .cta-arrow {
    font-size: 24px;
  }
}

/* 更多服务板块 */
.services-section {
  margin-top: @space-xxl;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: @space-lg;
}

.service-card {
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .service-banner {
    height: 160px;
    background-size: cover;
    background-position: center;
    position: relative;
    cursor: pointer;

    .overlay {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.4);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #ffffff;
      transition: all 0.3s;

      h3 {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 8px;
      }
      .view-more {
        font-size: 12px;
        opacity: 0;
        transform: translateY(10px);
        transition: all 0.3s;
        border: 1px solid #ffffff;
        padding: 4px 12px;
        border-radius: 20px;
      }
    }

    &:hover .overlay {
      background: rgba(52, 148, 236, 0.8);
      .view-more {
        opacity: 1;
        transform: translateY(0);
      }
    }
  }

  .service-product-list {
    padding: @space-lg;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .product-link {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: @text-secondary;
      cursor: pointer;
      transition: all 0.2s;

      i {
        font-size: 12px;
        color: @primary-color;
        opacity: 0;
        transition: all 0.2s;
      }

      &:hover {
        color: @primary-color;
        padding-left: 4px;
        i {
          opacity: 1;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .dynamic-grid,
  .services-grid {
    grid-template-columns: 1fr;
  }
}
</style>
